

module.exports = __webpack_require__.stylable.create(
    "Popover1028008911",
    {"classes":{"root":"Popover1028008911__root","arrow":"Popover1028008911__arrow"},"vars":{},"stVars":{"contentArrowSize":"7px","SH3":"0px 2px 17px 0px rgba(19, 55, 82, 0.11)","B3":"#459fed"},"keyframes":{}},
    "",
    3,
    "Popover1028008911",
    null
);
